// ─────────────────────────────────────────────────────────────────────────────
// mock-board-configs.ts
// Configuración de tableros tipo 'code'.
// Cuando conectes Firebase, este archivo ya no se usa —
// la misma estructura se guarda en Firestore bajo board_configs/{id}.
// ─────────────────────────────────────────────────────────────────────────────

import { CodeBoardConfig } from './board-config.model';

export const CODE_BOARD_CONFIGS: Record<string, CodeBoardConfig> = {

  '2BEkEjN9U1NXP6gzfvYi': {
    id:   '2BEkEjN9U1NXP6gzfvYi',
    name: 'Dashboard SDV — Reconocimiento',

    banner: {
      logoUrl:       'https://storage.googleapis.com/lucro-powerbi-storage/logo-postb.svg',
      subtitleFixed: 'Seguimiento de misiones',
    },

    // ── Filtros ──────────────────────────────────────────────────────────────
    filters: [
      {
        key:      'sdv',
        label:    'SDV',
        source:   'board_param',
        paramKey: 'sdv',              // lee svc.CurrentBoardData.parameters.sdv
        required: true,
      },
      {
        key:    'rdv',
        label:  'RDV',
        source: 'from_card',
        cardId: 331,
        field:  'RDV',
        mode:   'local',              // filtra en memoria sin recargar
      },
      // INACTIVO momentáneamente — filtro de Misión deshabilitado a pedido, se retoma más adelante.
      // {
      //   key:    'mision',
      //   label:  'Misión',
      //   source: 'from_card',
      //   cardId: 330,                  // mismo card que alimenta la pestaña Objetivos
      //   field:  'Mision',             // las opciones ya vienen filtradas por sdv+rdv
      //   mode:   'server',
      // },
      {
        key:     'estado',
        label:   'Estado',
        source:  'static',
        // Solo 2 estados visuales: 'Rechazado' y 'Pendiente' se agrupan como "Desaprobado"
        // (ver ajuste correspondiente en el query 419 de Metabase).
        options: ['Aprobado', 'Desaprobado'],
      },
    ],

    // ── Tabs ─────────────────────────────────────────────────────────────────
    tabs: [
      // ── Pestaña Objetivos ─────────────────────────────────────────────────
      {
        id:        'general',
        label:     'Objetivos',
        refreshOn: ['rdv'],           // al cambiar RDV recarga solo esta pestaña
        cards: [

          // Card 1 — KPI + Banner
          // Llama cards 319 (kpi personal) y 329 (kpi CEDI) en paralelo
          {
            id:               'kpi',
            component:        'kpi-status-card',
            updatesBanner:    true,
            transform:        'kpiStatusCard',
            queries: [
              {
                alias:  'kpi',
                cardId: 319,
                params: [
                  { filterKey: 'sdv', paramType: 'string/contains', templateTag: 'sdv', templateTagId: '56b89435-0815-41b0-9e3c-c6a53d48fdec', targetType: 'dimension' },
                  { filterKey: 'rdv', paramType: 'string/contains', templateTag: 'rdv', templateTagId: 'abdcf0fa-dc22-43b7-bb98-8bc70b8f4241', targetType: 'dimension', optional: true },
                ],
              },
              {
                alias:  'cedi',
                cardId: 329,
                params: [
                  { filterKey: 'sdv', paramType: 'string/contains', templateTag: 'sdv', templateTagId: '3a41aceb-ae91-4bb8-a5d5-1db9a5f52ad9', targetType: 'dimension' },
                ],
              },
            ],
          },

          // Card 2 — Tendencia diaria
          // Llama card 320, agrupa por día
          {
            id:                      'trend',
            component:               'chartjs-card',
            updatesBannerSparkline:  true,
            transform:               'trendBar',
            queries: [
              {
                alias:  'trend',
                cardId: 320,
                params: [
                  { filterKey: 'sdv', paramType: 'string/contains', templateTag: 'sdv', templateTagId: '172a2074-1376-4baf-88f6-b22e2039b895', targetType: 'dimension' },
                  { filterKey: 'rdv', paramType: 'string/contains', templateTag: 'rdv', templateTagId: 'd262c8fb-d4f4-4bc9-8dd6-9a009d2e1ea9', targetType: 'dimension', optional: true },
                ],
              },
            ],
          },

          // Card 3 — Cumplimiento por Misión + Logros
          // Llama card 330, produce chartjs-card + achievement-card
          {
            id:        'mission',
            component: 'mission-cards',
            transform: 'missionCards',
            queries: [
              {
                alias:  'missions',
                cardId: 330,
                params: [
                  { filterKey: 'sdv', paramType: 'string/contains', templateTag: 'sdv', templateTagId: 'ff80ffa0-1752-4435-9cd7-61121a24e6bf', targetType: 'dimension' },
                  { filterKey: 'rdv', paramType: 'string/contains', templateTag: 'rdv', templateTagId: 'dc52346b-dc6f-4f5e-a0e8-e293186bca44', targetType: 'dimension', optional: true },
                ],
              },
            ],
          },

          // Card 4 — Cumplimiento por RDV
          // Llama card 331 una vez (sin filtro RDV), filtra localmente
          {
            id:        'rdv',
            component: 'chartjs-card',
            transform: 'rdvCombo',
            queries: [
              {
                alias:  'rdv',
                cardId: 331,
                params: [
                  { filterKey: 'sdv', paramType: 'string/contains', templateTag: 'sdv', templateTagId: 'e30b2fd8-188c-49eb-a5ac-1f8e49e010ec', targetType: 'dimension' },
                ],
              },
            ],
          },

          // Card 5 — Ranking mejores del CEDI (card 332)
          // Params distintos: usa variable sdv_cedi en lugar de dimension sdv
          {
            id:        'ranking',
            component: 'chartjs-card',
            transform: 'rankingCombo',
            queries: [
              {
                alias:  'ranking',
                cardId: 332,
                params: [
                  { filterKey: 'sdv', paramType: 'string/=', templateTag: 'sdv_cedi', templateTagId: '0bd412b3-0d33-4e87-8734-515a33c505a1', targetType: 'variable' },
                ],
              },
            ],
          },

        ],
      },

      // ── Pestaña Ejecuciones ───────────────────────────────────────────────
      {
        id:        'sdv-detail',
        label:     'Ejecuciones',
        refreshOn: ['rdv', 'dateRange', 'estado'], // 'mision' fuera mientras el filtro está inactivo
        cards: [

          // Card 1 — Lista de ejecuciones con foto
          // Card 419: sdv + rdv (vendorcode) + dateRange + estado + paginación (mision inactivo, ver arriba)
          {
            id:        'executions',
            component: 'execution-list',
            transform: 'executionList',
            queries: [
              {
                alias:  'detail',
                cardId: 419,
                params: [
                  { filterKey: 'sdv',       paramType: 'string/contains', templateTag: 'sdv',         templateTagId: '017585b0-abd5-4deb-8a45-de07db221088', targetType: 'dimension' },
                  { filterKey: 'rdv',       paramType: 'string/contains', templateTag: 'vendorcode',  templateTagId: 'fddee4f6-a966-48d7-8084-d9c58d2e2545', targetType: 'dimension', optional: true },
                  { filterKey: 'dateRange', paramType: 'date/range',      templateTag: 'fecha_rango', templateTagId: '50742a61-e39b-4be4-8b6d-afb5c9060605', targetType: 'dimension' },
                  // INACTIVO momentáneamente junto con el filtro de Misión (ver `filters` arriba)
                  // { filterKey: 'mision', paramType: 'string/contains', templateTag: 'mision', templateTagId: 'cd2759d4-0659-442c-ade8-c21ce1b27b7f', targetType: 'dimension', optional: true },
                  { filterKey: 'estado',    paramType: 'string/=',        templateTag: 'estado',      templateTagId: 'ddabd4ec-482c-4605-ba09-e2d9916da20b', targetType: 'variable', optional: true },
                  { filterKey: '_static',   paramType: 'number/=',        templateTag: 'limite',      templateTagId: 'ddafa0f6-a9e5-444f-b720-abf8f295a2ff', targetType: 'variable', staticValue: 50 },
                  { filterKey: 'offset',    paramType: 'number/=',        templateTag: 'offset',      templateTagId: '293cbb84-be12-4a2a-84b6-e9a7c80aa3fb', targetType: 'variable' },
                ],
              },
              // INACTIVO momentáneamente — solo poblaba el select de "Misión", ahora deshabilitado.
              // {
              //   alias:  'missionsCatalog',
              //   cardId: 330,
              //   params: [
              //     { filterKey: 'sdv', paramType: 'string/contains', templateTag: 'sdv', targetType: 'dimension' },
              //     { filterKey: 'rdv', paramType: 'string/contains', templateTag: 'rdv', targetType: 'dimension', optional: true },
              //   ],
              // },
            ],
          },

        ],
      },
    ],
  },


  // ── Dashboard principal — Postobón Field Intelligence ────────────────────
  'GJ2pvI72ATsjPzApyrHj': {
    id:   'GJ2pvI72ATsjPzApyrHj',
    name: 'Dashboard Reconocimiento · Prueba',

    banner: {
      logoUrl:       'https://storage.googleapis.com/lucro-powerbi-storage/logo-postb.svg',
      subtitleFixed: 'Reconocimiento de tareas',
      badgeText:     'En vivo',
    },

    filters: [],

    tabs: [

      // ── TAB 1: RESUMEN — Mapa de tiendas ──────────────────────────────────
      {
        id:        'resumen',
        label:     'Tiendas',
        refreshOn: [],
        cards: [
          {
            id:        'geo-heatmap',
            component: 'store-heatmap-card',
            transform: 'storeHeatmap',
            queries: [
              // ⭐ Query 435: lista completa de PDV con geolocalización (mapa)
              // El detalle de cada PDV se carga lazy con query 431 al hacer clic.
              {
                alias:  'stores',
                cardId: 435,
                params: [],
              },
              // ⭐ Query 436: catálogo de objetos de librería (id → nombre)
              // Se usa para poblar el buscador de productos del mapa.
              {
                alias:  'catalog',
                cardId: 436,
                params: [],
              },
            ],
          },
        ],
      },

      // ── TAB 2: EJECUCIONES ────────────────────────────────────────────────
      {
        id:        'sdv-detail',
        label:     'Ejecuciones',
        refreshOn: [],
        cards: [
          {
            id:        'executions',
            component: 'execution-list',
            transform: 'recognitionList',
            queries: [
              {
                alias:  'detail',
                cardId: 432,
                params: [
                  // fecha_inicio → variable {{fecha_inicio}} en Metabase
                  {
                    filterKey:     'dateStart',
                    paramType:     'date/single-start',
                    templateTag:   'fecha_inicio',
                    templateTagId: '7f97e2cd-c986-40e0-9ef9-e980569b9369',
                    targetType:    'variable',
                  },
                  // fecha_fin → variable {{fecha_fin}} en Metabase
                  {
                    filterKey:     'dateEnd',
                    paramType:     'date/single-end',
                    templateTag:   'fecha_fin',
                    templateTagId: '4bd4cd0a-e73c-4aa1-a7ef-47d336b6b016',
                    targetType:    'variable',
                  },
                  // limite → paginación server-side (50 registros por página)
                  {
                    filterKey:     '_static',
                    paramType:     'number/=',
                    templateTag:   'limite',
                    templateTagId: 'ce344c0c-c5c6-4a4a-aed6-f5e623468e2e',
                    targetType:    'variable',
                    staticValue:   50,
                  },
                  // offset → siempre 0 por ahora
                  {
                    filterKey:     '_static',
                    paramType:     'number/=',
                    templateTag:   'offset',
                    templateTagId: '4723ef0b-e95d-4691-b20d-a2bdbef5f783',
                    targetType:    'variable',
                    staticValue:   0,
                  },
                ],
              },
            ],
          },
        ],
      },

    ],
  },

  // ── Tablero Objetos Detectados — card 432 ─────────────────────────────────
  'RK9mXqT4vBsLpAeCdWzY': {
    id:   'RK9mXqT4vBsLpAeCdWzY',
    name: 'Dashboard Objetos Detectados',

    banner: {
      logoUrl:       'https://storage.googleapis.com/lucro-powerbi-storage/logo-postb.svg',
      subtitleFixed: 'Análisis de objetos detectados por reconocimiento',
      badgeText:     'En vivo',
    },

    filters: [],

    tabs: [
      {
        id:        'objetos',
        label:     'Objetos Detectados',
        refreshOn: [],
        cards: [
          {
            id:        'objects',
            component: 'detected-objects-card',
            transform: 'detectedObjectsList',
            queries: [
              {
                alias:  'recs',
                cardId: 432,
                params: [],
              },
            ],
          },
        ],
      },
    ],
  },

  // ── Tablero Mapa de Calor Geográfico (datos simulados) ───────────────────
  'geo-heatmap-demo': {
    id:   'geo-heatmap-demo',
    name: 'Mapa de Calor — Tiendas',

    banner: {
      logoUrl:       'https://storage.googleapis.com/lucro-powerbi-storage/logo-postb.svg',
      subtitleFixed: 'Distribución geográfica de tiendas por localidad',
      badgeText:     'Demo',
    },

    filters: [],

    tabs: [
      {
        id:        'geo-heatmap',
        label:     'Mapa de Calor',
        refreshOn: [],
        cards: [
          {
            id:        'geo-heatmap',
            component: 'store-heatmap-card',
            transform: 'storeHeatmap',
            queries:   [],   // sin query → datos simulados dentro del componente
          },
        ],
      },
    ],
  },

};
